module.exports = __webpack_public_path__ + "media/img/uploads/event-thumb-04-cf4a46a48f87718c9f616d8de4c249d2.jpg";